var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createContext, useContext, useEffect, useState } from "react";
import { triggerOverrideTranslations } from "@/services/i18n";
var defaultTenantContext = {
    tenantId: "",
    setTenantId: function () { return undefined; },
    tenant: undefined,
    setTenant: function () { return undefined; },
};
export var TenantContext = createContext(defaultTenantContext);
export var TenantContextProvider = function (props) {
    var _a;
    var _b = useState(localStorage.getItem("selected-tenant-id") || null), tenantId = _b[0], setTenantId = _b[1];
    var setTenantIdWrapper = function (tenantId) {
        if (null === tenantId) {
            localStorage.removeItem("selected-tenant-id");
        }
        else {
            localStorage.setItem("selected-tenant-id", tenantId);
        }
        setTenantId(tenantId);
    };
    var _c = useState(undefined), tenant = _c[0], setTenant = _c[1];
    // Overwrites translations based on the settings config
    useEffect(function () {
        var _a;
        var i18nSettings = (_a = tenant === null || tenant === void 0 ? void 0 : tenant.settings) === null || _a === void 0 ? void 0 : _a.i18n;
        if (i18nSettings) {
            triggerOverrideTranslations(i18nSettings);
        }
    }, [(_a = tenant === null || tenant === void 0 ? void 0 : tenant.settings) === null || _a === void 0 ? void 0 : _a.i18n]);
    var setTenantWrapper = function (newTenant) {
        setTenant(newTenant);
        if ((newTenant === null || newTenant === void 0 ? void 0 : newTenant.id) && newTenant.id !== tenantId) {
            setTenantId(newTenant.id);
        }
    };
    // Setup the context provider
    return (_jsx(TenantContext.Provider, __assign({ value: {
            tenantId: tenantId,
            setTenantId: setTenantIdWrapper,
            tenant: tenant,
            setTenant: setTenantWrapper,
        } }, { children: props.children })));
};
export var useTenantStore = function () {
    var _a = useContext(TenantContext), tenantId = _a.tenantId, setTenantId = _a.setTenantId;
    return [tenantId, setTenantId];
};
